<template>
  <BaseContainer :title="`订阅${props.rights_name}`" :closeRefresh="true" @cancel="closeModal">
    <div
      class="w-full h-full flex flex-col gap-x-[10px] bg-back-0 rounded-[12px] justify-center items-center p-[24px] pb-[44px]"
    >
      <template v-if="payFail">
        <PayFail :needRepayBtn="false"></PayFail>
        <div class="mt-[20px] bar w-[92%] mx-auto h-[1px] bg-back-3"></div>
        <PaySuccTip class="my-[28px]" />
      </template>
      <template v-else-if="paySucc">
        <PaySucc :title="price.string" :desc="`订阅${props.rights_name}`" />
        <div class="bar w-[92%] mx-auto h-[1px] bg-back-3"></div>
        <PaySuccTip class="my-[28px]" />
      </template>
      <template v-else>
        <XAlert v-if="props.tip" type="warning" class="w-full">
          {{ props.tip }}
        </XAlert>
        <h3 class="tip mt-[20px]">请用支付宝扫码支付</h3>
        <div class="qrcode h-[140px] w-[140px] bg-back-2 overflow-hidden rounded-[8px] p-[5px]">
          <div class="bg-back-0 p-[5px] h-full">
            <iframe
              :src="props.qr_code_url"
              class="qrcode-iframe"
              frameborder="0"
              scrolling="no"
            ></iframe>
          </div>
        </div>
        <div class="right-name mt-[20px]">
          {{ props.rights_name }}
        </div>
        <div class="price">{{ price.string }}</div>
        <div class="valid-time">有效期：{{ dateRange }}</div>
      </template>
    </div>
  </BaseContainer>
</template>

<script lang="ts" setup>
import BaseContainer from '../baseContainer/index.vue';
import PaySucc from '../pay-succ.vue';
import PayFail from '../pay-fail.vue';
import PaySuccTip from '../pay-succ-tip.vue';
import XAlert from '@/components/xAlert/index.vue';
import { formatPrice } from '@/utils/equity-helper';
import { reqOrder } from '~/api';
import { PAY_STATUS, type ORDER_BEHAVIOR } from '~/api/interface';

const props = defineProps<{
  behavior: ORDER_BEHAVIOR;
  id: number;
  pay_fee: number;
  qr_code_url: string;
  status: PAY_STATUS;
  rights_name: string;
  start_timestamp: number;
  expired_timestamp: number;
  tip: string;
  track?: () => void;
  onCancel: () => void;
}>();

function closeModal() {
  props.onCancel();
}

const paySucc = ref(false);
const payFail = ref(false);

const { $dayjs } = useNuxtApp();
let lid: number = 0;

const dateRange = computed(() => {
  const start = $dayjs(props.start_timestamp * 1000).format('YYYY.MM.DD');
  const end = $dayjs(props.expired_timestamp * 1000).format('YYYY.MM.DD');
  return `${start} - ${end}`;
});

const price = computed(() => formatPrice(props.pay_fee));
const abort = ref<AbortController>();

async function checkStatus() {
  // 退出正在进行 pending 的请求
  if (abort.value) {
    abort.value.abort();
  }
  abort.value = new AbortController();
  const res = await reqOrder(props.id, {
    signal: abort.value.signal,
  });
  if (res.data) {
    if ([PAY_STATUS.PAID].includes(res.data.status)) {
      paySucc.value = true;
      props.track?.();
      clearInterval(lid);
    } else if ([PAY_STATUS.FAIL].includes(res.data.status)) {
      payFail.value = true;
    }
  }
}

function startLoop() {
  clearInterval(lid);
  lid = window.setInterval(checkStatus, 5000);
}

onMounted(() => {
  startLoop();
});

onBeforeUnmount(() => {
  clearInterval(lid);
  abort.value?.abort();
});
</script>

<style lang="scss" scoped>
.tip {
  color: var(--text-1);
  font-weight: 500;
}
.right-name {
  color: var(--warning-8);
  font-size: 14px;
  font-weight: 500;
}
.price {
  color: var(--error-6);
  font-size: 28px;
  line-height: 42px;
  margin-bottom: 6px;
}
.qrcode {
  padding: 5px;
}
.qrcode-iframe {
  width: 150px;
  transform: scale(calc(120 / 150));
  transform-origin: left top;
}
</style>
